<template>
  <form-hint v-if="collapsed" :text="computedHelp" class="form-field__message" :class="textColor" />
  <component :is="as" v-else-if="computedHelp" class="form-field__message" :class="[textColor]">{{ computedHelp }}</component>
</template>

<script>
import { compactFormHintsKey } from '@/domain/formHints'
import FormHint from '@/components/ui/forms/FormHint.vue'
import { computed, inject, unref } from 'vue'
import { useValidationState } from '@/composables/useValidationState'

export default {
  name: 'FieldHelp',
  components: { FormHint },
  props: {
    as: { type: String, default: 'div' },
    help: String,
    error: [Boolean, String, Array],
    success: [Boolean, String]
  },
  setup (props) {
    const compact = inject(compactFormHintsKey, false)
    const { getValidationColor, getHelpText } = useValidationState()

    const computedHelp = computed(() => {
      return getHelpText(props.help, props.error)
    })

    const textColor = computed(() => {
      const color = getValidationColor(props.error, props.success)
      return color ?? 'text-theme-text-secondary'
    })

    return {
      computedHelp,
      collapsed: computed(() => unref(compact) && !props.error && !props.success && Boolean(computedHelp.value?.trim())),
      textColor
    }
  }
}
</script>
